import { Button, Col, Modal, Row, Space, Typography, theme } from "antd";
import CloseIcon from "../../assets/images/icon/closeIcon.svg";

const { Title, Text } = Typography;

const { useToken } = theme;

const FailModal = ({ open, setOpen, title, subTitle, setErrMsg }) => {
  const { token } = useToken();

  const handleCancel = () => {
    setOpen(false);
    setErrMsg("");
  };

  return (
    <Modal
      centered
      open={open}
      title=""
      onCancel={handleCancel}
      footer={false}
      width={400}
    >
      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "center", marginTop: 30 }}
      >
        <img src={CloseIcon} width={80} alt="Close Icon" />
      </Space>

      <Row justify="center">
        <Col span={24} align="center">
          <Title level={5}>{title || "มีบางอย่างผิดพลาด"}</Title>
        </Col>
        <Col span={24} align="center">
          <Text className="sub-title">
            {subTitle || "มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"}
          </Text>
        </Col>
      </Row>

      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "center", margin: "20px 0" }}
      >
        <Button
          key="back"
          onClick={handleCancel}
          style={{ backgroundColor: token.thPrimary, color: "white" }}
        >
          ตกลง
        </Button>
      </Space>
    </Modal>
  );
};

export default FailModal;
